$(window).on('load', function () {
    expandHeader();
    amendHomeLinkOnHeaderLogo();

    $(window).trigger('resize');

    const $html = $('html');
    const gtmTag = typeof $html.attr('data-gtm') !== 'undefined' ? $html.attr('data-gtm') : null;
    const gtagTag = typeof $html.attr('data-gtag') !== 'undefined' ? $html.attr('data-gtag') : null;

    (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({
            'gtm.start':
                new Date().getTime(),
            event: 'gtm.js'
        });
        var f = d.getElementsByTagName(s)[0];
        var j = d.createElement(s);
        var dl = l != 'dataLayer' ? '&l=' + l : ''; // eslint-disable-line eqeqeq
        j.async = true;
        j.src =
            'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);

        if (gtagTag !== null && gtagTag.length !== 0) {
            window.dataLayer = window.dataLayer || [];
            function gtag() {
                dataLayer.push(arguments);// eslint-disable-line no-undef
            }
            gtag('js', new Date());

            gtag('config', gtagTag);
        }
    })(window, document, 'script', 'dataLayer', gtmTag);

    // Allow accessing elements behind MIVA shadow
    allowClickingBehindMivaShadow();

    createIFrameObserver();
});

$(document).ready(function () {
    addPaginationToMetaDescription();
    amendHomeLinkOnHeaderLogo();

    if ($(window).width() > 768) {
        setDesktopHomePageHero();
    }
    else {
        setMobileHomePageHero();
    }

    /**
     * Initialize mobile menu
     */
    const $searchBox = $('#mi-corpo-mobile-menu-search-box');

    if (!$searchBox.closest('.mobile-megamenu').length) {
        $('#mi-corpo-mobile-menu-search-box').css('display', 'none');
    }

    let getMenuHeight = function (menuElement) {
        return menuElement.find('.levelHolderClass ul')[0].offsetHeight || 0;
    };

    let setMenuHeightAs = function (newHeight) {
        let pxHeight = newHeight + 'px';

        $('#menu_multilevelpushmenu').css('height', pxHeight);
        $('#menu')
            .css('min-height', pxHeight)
            .css('height', pxHeight);
    };

    const $responsiveMenu = $('#responsiveMenu');
    const $mobileMainmenu = $('.mobile-mainmenu #menu');

    if ($mobileMainmenu.length) {
        $mobileMainmenu.multilevelpushmenu({
            onItemClick: function () {
                // Third argument is clicked item (<li> element)
                const $item = arguments[2];
                // Anchor href
                const itemHref = $item.find('a:first').attr('href');
                // Redirecting the page
                location.href = itemHref;
            },
            onGroupItemClick: function () {
                const navigationSublevel = $(arguments[3].menu[0])[0];
                $(navigationSublevel).css('margin-left', '-9px');

                setMenuHeightAs(getMenuHeight($(arguments[2][0])) + 90);
            },

            onBackItemClick: function () {
                $(arguments[1][0]).css('margin-left', '-300px');

                setMenuHeightAs(getMenuHeight($(arguments[2].container.get(0))) + 12);
            },

            containersToPush: [$('#pushobj')],
            mode: 'cover'
        });

        setMenuHeightAs(getMenuHeight($responsiveMenu.find('#menu #menu_multilevelpushmenu')) + 12);
    }

    $responsiveMenu.css('display', 'none');

    $('.mi-corpo-navbar-button').on('touchend click', function () {
        $('#responsiveMenu').css('display', 'block');
        $('body').css('overflow', 'hidden');
        return false;
    });

    $('#mi-corpo-mobile-menu-search-button').on('click', function () {
        const $miCorpoMobileMenuSearchBox = $('#mi-corpo-mobile-menu-search-box');
        if ($miCorpoMobileMenuSearchBox.css('display') === 'none') {
            $miCorpoMobileMenuSearchBox.css('display', 'inline-block');
        }
        else {
            $miCorpoMobileMenuSearchBox.css('display', 'none');
        }
        return false;
    });

    $('#mi-corpo-mobile-menu-search-box-text-box-component, #mi-corpo-header-menu-item-searchtext').keyup(function (e) {

        let indexCatalogue = '';
        const $html = $('html');
        const siteId = $html.attr('data-site-id');
        switch (siteId) {
            case 'solaris':
                indexCatalogue = 'solaris-search-index';
                break;
            default:
                indexCatalogue = 'search-mi';
        }

        if (e.keyCode === 13) {
            const searchText = $(this).val();
            const language = $html.attr('lang');
            const redirectedUrl = '/' + language + '/search?indexCatalogue=' + indexCatalogue + '&searchQuery=' + searchText;
            $(location).attr('href', redirectedUrl);
        }
    });

    $('#mi-corpo-mobile-menu-close-button').on('touchend click', function () {
        $('#responsiveMenu').removeAttr('style').hide();

        $('body').css('overflow', 'unset');
        return false;
    });

    $('.mi-corpo-header-CareerMenuDots').on('click', function () {
        expandHeader();
    });

    $(window).on('resize', function () {
        if ($(window).width() > 768) {
            expandHeader();
            $('#responsiveMenu').hide();
            setDesktopHomePageHero();
        }
        else {
            setMobileHomePageHero();

            // Should close megamenu if currently displayed
            $('.megamenu').css('display', 'none');
            const $currentClicked = $('.level-1-item.clicked');

            if ($currentClicked.length) {
                $currentClicked.removeClass('active clicked');
            }
        }
        adjustFooterMenu();

    });

    $(window).on('scroll', function () {
        if ($(window).width() > 768) {
            if (window.scrollY === 0) {
                //user scrolled to the top of the page, then back to expanded menu
                expandHeader();
            }
            else {
                if (!$('#mi-corpo-header').hasClass('mi-corpo-header-homepagehero')) {
                    collapseHeader();
                }

            }
        }
    });

    $('.mi-corpo-mobile-menu').css('visibility', 'visible');
    $('.mi-corpo-countrySelector-banner').css('display', 'block');

    /*Checking headers top position if ConsentTracking dialog is active */

    positionHeaderInResizeWithCookiesDialog();

    $(window).resize(function () {
        positionHeaderInResizeWithCookiesDialog();
    });

    if ($('.mi-technology-page-content').length > 0) {
        $('.mi-corpo-header-breadcrumbs').hide();
        jQuery(window).resize(); // Use to trigger resize for the whole page.
    }

    $(window).trigger('resize');

    $('.action-open-cookies-banner-popin').off('click').on('click', function () {
        UC_UI.showSecondLayer();// eslint-disable-line no-undef
    });
});

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('iframe').forEach(iframe => {
        iframe.setAttribute('loading', 'lazy');

        const src = iframe.getAttribute('src');
        iframe.setAttribute('data-src', src);
        iframe.removeAttribute('src');
    });
});

function addPaginationToMetaDescription() {
    const urlPathsToPaginate = ['news', 'blog/post'];
    const currentUrlPath = document.URL.substring(0, document.URL.lastIndexOf('/'));
    const currentUrlLastElement = document.URL.substring(document.URL.lastIndexOf('/') + 1);

    if (isNaN(currentUrlLastElement)) {
        return;
    }

    urlPathsToPaginate.forEach((urlPath) => {
        if (currentUrlPath.endsWith(urlPath)) {
            addTextToMetaDescription(' - Page ' + currentUrlLastElement);
            return;
        }
    });
}

function addTextToMetaDescription(textToAdd) {
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
        metaDescription.content += textToAdd;
    }
}

function expandHeader() {
    $('.mi-corpo-header-mainmenu')
        .removeClass('col-sm-8')
        .addClass('col-lg-12')
        .removeClass('mi-corpo-header-mainmenu-collapsed');
    $('.mi-corpo-main-header').removeClass('mi-corpo-main-header-collapsed');
    $('.navigation-mi .mi-corpo-nav-link').removeClass('mi-corpo-nav-link-collapsed');
    $('.mi-corpo-header-CareerMenu').removeClass('mi-corpo-header-CareerMenu-collapsed');
    $('.mi-corpo-header-CareerMenuDots').removeClass('mi-corpo-header-CareerMenuDots-collapsed');
    $('.mi-corpo-header-breadcrumbs').removeClass('mi-corpo-header-breadcrumbs-collapsed');
}

function collapseHeader() {
    $('.mi-corpo-header-mainmenu').removeClass('col-lg-12')
        .addClass('col-sm-8')
        .addClass('mi-corpo-header-mainmenu-collapsed');
    $('.mi-corpo-main-header').addClass('mi-corpo-main-header-collapsed');
    $('.navigation-mi .mi-corpo-nav-link').addClass('mi-corpo-nav-link-collapsed');
    $('.mi-corpo-header-CareerMenu').addClass('mi-corpo-header-CareerMenu-collapsed');
    $('.mi-corpo-header-CareerMenuDots').addClass('mi-corpo-header-CareerMenuDots-collapsed');
    $('.mi-corpo-header-breadcrumbs').addClass('mi-corpo-header-breadcrumbs-collapsed');
}

function amendHomeLinkOnHeaderLogo() {
    let amendedHomeLink = generateHomeLink();
    $('.mi-corpo-header-logo > a').each(function () {
        if ($(this).attr('href').includes('/home')) {
            $(this).attr('href', amendedHomeLink);
        }
    });
}

function generateHomeLink() {
    const URL_SEPARATOR = '/';
    const PROTOCOL_SEPARATOR = '//';

    let amendedHomeLink = document.location.protocol + PROTOCOL_SEPARATOR + document.location.hostname;
    let port = document.location.port;

    if (port !== '') {
        amendedHomeLink = amendedHomeLink + ':' + port;
    }

    const LANGUAGE = $('html').attr('lang').toLowerCase();
    if (LANGUAGE !== 'en') {
        amendedHomeLink = amendedHomeLink + URL_SEPARATOR + LANGUAGE;
    }

    return amendedHomeLink;
}

function positionHeaderInResizeWithCookiesDialog() {
    let $trackingConsentDialog = $('#tracking-consent-dialog');
    if ($trackingConsentDialog.length === 1) {
        let headerHeight = $trackingConsentDialog.height();
        $('.mi-corpo-header-area').css('top', headerHeight + 32);
    }
}

/*
 This function to set the mobile homepagehero image as a main header background image
*/
function setMobileHomePageHero() {
    let mobileImagePath = $('.mi-mobile-homepagehero').css('background-image');
    $('.mi-corpo-header-homepagehero').css('background-image', mobileImagePath);
}

function setDesktopHomePageHero() {
    let desktopImagePath = $('.mi-desktop-homepagehero').css('background-image');
    $('.mi-corpo-header-homepagehero').css('background-image', desktopImagePath);
}


/*** FOOTER  ****/

function adjustFooterMenu() {
    if ($(window).width() > 960) {

        $('[id^="collapse"]').each(function () {
            $('#' + $(this).attr('id')).addClass('show');
        });

        $('[id^="heading"]').each(function () {
            $('#' + $(this).attr('id') + ' > a').attr('data-toggle', '');
        });

        $('[id^="mi-footermenu-header-expandarrow"]').each(function () {
            $('#' + $(this).attr('id')).hide();
        });

        $('[id^="mi-footermenu-header-underline"]').each(function () {
            $('#' + $(this).attr('id')).hide();
        });
    }
    else {

        $('[id^="collapse"]').each(function () {
            $('#' + $(this).attr('id')).removeClass('show');
        });

        $('[id^="heading"]').each(function () {
            $('#' + $(this).attr('id') + ' > a').attr('data-toggle', 'collapse');
        });

        $('[id^="mi-footermenu-header-expandarrow"]').each(function () {
            $('#' + $(this).attr('id')).show();
        });

        $('[id^="mi-footermenu-header-underline"]').each(function () {
            $('#' + $(this).attr('id')).show();
        });
    }

}

function isCurrentPageHomepage() {
    const EMPTY_STRING = '';
    const URL_SEPARATOR = '/';

    const LANGUAGE = $('html').attr('lang');
    const LANGUAGE_PATHNAME_PREFIX = URL_SEPARATOR + LANGUAGE;

    let pathname = window.location.pathname.toLowerCase();

    if (pathname.length >= LANGUAGE_PATHNAME_PREFIX.length &&
        pathname.substring(0, LANGUAGE_PATHNAME_PREFIX.length) === LANGUAGE_PATHNAME_PREFIX) {

        pathname = pathname.substring(LANGUAGE_PATHNAME_PREFIX.length);
    }

    pathname = pathname.replaceAll(URL_SEPARATOR, EMPTY_STRING);

    return (pathname === EMPTY_STRING || pathname === 'home');
}

function allowClickingBehindMivaShadow() {
    const host = document.querySelector('mavenoid-assistant #mavenoid-shadow-root');

    if (host && host.shadowRoot) {
        const shadow = host.shadowRoot;

        const applyStyle = () => {
            const el = shadow.querySelector('#continuous-surface');
            if (el) {
                el.style.pointerEvents = 'none';
            }
        };

        // Run once initially
        applyStyle();

        // Observe changes inside shadow root DOM
        // Set style whenever widget in opened
        const observer = new MutationObserver(() => {
            const popupOpen = shadow.querySelector('.widget-open');
            if (popupOpen) {
                applyStyle();
            }
        });

        observer.observe(shadow, {
            subtree: true,
            attributes: true
        });
    }
}

function createIFrameObserver() {
    const iframes = document.querySelectorAll('iframe:not(.g-recaptcha iframe)');

    const observerOptions = {
        rootMargin: '200px'
    };

    const iframeObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const iframe = entry.target;
                const src = iframe.getAttribute('data-src');
                iframe.setAttribute('src', src);

                // Unobserve once src is set
                iframeObserver.unobserve(iframe);
            }
        });
    }, observerOptions);

    iframes.forEach((iframe) => {
        iframeObserver.observe(iframe);
    });
}
